module.exports = __webpack_public_path__ + "img/AFMS_DLEFT_OPEN.08a6f18c.png";